import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import HideValueT from '../../RestrictedAccess/HideValueT';
const PRZText = ({ isInternalLink, isExternalLink, className, text, internalUrl, externalUrl, onClick, required, style, infoMessage, infoMessageStyle = {
    marginLeft: '5px',
    color: 'grey',
    cursor: 'pointer',
}, hideText, popOverMessage, }) => {
    return (_jsxs("div", { className: className, style: style, onClick: onClick, children: [(isInternalLink || isExternalLink) ? (_jsx(Link, { to: internalUrl || externalUrl || '#', children: hideText ? (_jsx(HideValueT, { showPopOver: true, popOverMessage: popOverMessage })) : (text) })) : hideText ? (_jsx(HideValueT, { showPopOver: true, popOverMessage: popOverMessage })) : (text), required && (_jsx("span", { style: { color: 'red', marginLeft: '2px' }, children: "*" })), infoMessage && (_jsx(Tooltip, { title: infoMessage, children: _jsx(InfoCircleOutlined, { style: infoMessageStyle }) }))] }));
};
export default PRZText;
